import { reactive } from 'vue';

export const loadingStore = reactive({
  isLoading: false,
  message: 'Loading...',
  spinnerColor: '#3498db', // 기본 색상 (파란색)

  showLoading({ message = 'Smart Camp', color = '#3498db' } = {}) {
    this.isLoading = true;
    this.message = message;
    this.spinnerColor = color;
  },
  hideLoading() {
    setTimeout(() => {
      this.isLoading = false;  
    }, 500);
    // this.isLoading = false;
  },
});